
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, MenuItem, TextField } from "@mui/material";
import { LayoutCrearDoc } from "../../layouts";
import { roles_permitidos } from "../../../data";
import { BotonesAndCargando } from "../../components/botones";
import { useUsuarioXID } from "../../../hooks/cache";
import { AvatarScreen } from "../../ui";
import { useQueryClient } from "@tanstack/react-query";
import { startEditarUsuario } from "../../../services";
import { useImagenStore } from "../../../stores";

import Swal from "sweetalert2";
import { useValidarRoles } from "../../../hooks";



const initUser = {
    nombre: "",
    cedula: "",
    ciudad: "",
    direccion: "",
    movil: "",
    establecimiento: "",
    profesion: "",
    role: "",
    email: "",
};



export const ActualizarUsuario = () => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { imagen, valorImagen } = useImagenStore();
    const { permitirXRol } = useValidarRoles();
    const { data } = useUsuarioXID(id); 
    const [cargando, setCargando] = useState(false);


    useEffect( () => {
        if( data ){
            setFormUsuario({ ...data });
            valorImagen(data.img)
        }
    }, [data]);



    const [formUsuario, setFormUsuario ] = useState( initUser );
    const { nombre, cedula, ciudad, direccion, movil, role, establecimiento, profesion, email } = formUsuario;
    const handleInputChange = ({ target }) => {
        setFormUsuario({
            ...formUsuario,
            [target.name]: target.value
        });
    }



    const actualizarUsuario = async (e) => {
        e.preventDefault();

        const campos = [nombre, email, role, direccion, movil, profesion, cedula];
        if (campos.some(campo => !campo.trim())) {
            return Swal.fire('Error', 'Debes llenar todos los campos del formulario', 'error');
        }

        const { isConfirmed } = await Swal.fire({
            title: 'Actualizar Usuario',
            text: `¿Está seguro de actualizar a ${nombre}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, actualizar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
        });

        if(!isConfirmed) return;

        setCargando(true);
        const resp = await startEditarUsuario({ ...formUsuario, id, img: imagen });
        setCargando(false);
        if(resp) { queryClient.invalidateQueries({ queryKey: ['user-xrole'] }) }
    };




    return (

        <LayoutCrearDoc titulo={'Actualizar Usuario'} add={false}>
            {/* <MostrarImagen /> */}
            <AvatarScreen carpeta="usuarios" />

            <form className="formulario-total" onSubmit={ actualizarUsuario } >
            <Grid container spacing={3} sx={{mt:1}}>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Nombre Usuario'
                        type='text'
                        placeholder='Nombre Usuario'
                        fullWidth
                        name="nombre"
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Cedula Usuario'
                        type='text'
                        placeholder='Cedula Usuario'
                        fullWidth
                        name="cedula"
                        value={ cedula }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Correo Electronico'
                        type='text'
                        placeholder='Correo Electronico'
                        fullWidth
                        name="email"
                        value={ email }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Movil'
                        type='number'
                        placeholder='Movil'
                        fullWidth
                        name="movil"
                        value={ movil }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        variant="outlined"
                        label='Establecimiento'
                        type='text'
                        placeholder='Establecimiento'
                        fullWidth
                        name="establecimiento"
                        value={ establecimiento }
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        variant="outlined"
                        label='Profesión'
                        type='text'
                        placeholder='Profesión'
                        fullWidth
                        name="profesion"
                        value={ profesion }
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        variant="outlined"
                        label='Ciudad'
                        type='text'
                        placeholder='Ciudad'
                        fullWidth
                        name="ciudad"
                        value={ ciudad }
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Dirección'
                        type='text'
                        placeholder='Dirección'
                        fullWidth
                        name="direccion"
                        value={ direccion }
                        onChange={ handleInputChange }
                    />
                </Grid>

                {(permitirXRol('SUPERADMIN', 'ADMINISTRADOR')) &&
                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        required
                        variant="outlined"
                        select
                        label="Seleccione Rol"
                        fullWidth
                        name='role'
                        value={ role }
                        onChange={ handleInputChange }
                    >
                        <MenuItem value="">Seleccione Un Rol</MenuItem>
                        {roles_permitidos.map( item => (
                            <MenuItem key={item} value={item}>{item}</MenuItem>
                        ))}
                    </TextField>
                </Grid>
                }
            </Grid>
                <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                    <Grid item xs={12} sm={6} md={5}>
                        <BotonesAndCargando
                            cargando={cargando}
                            titulo='Actualizar Usuario'
                            titulo2="Loading..."
                            icon1="save"
                            icon2="save"
                            esSubmit
                        />
                    </Grid>
                </Grid>

            </form>
        </LayoutCrearDoc>
    )
}
